import { useCountryData } from 'src/components/visibility/hooks/useCountryData';
import ClusterManager from './cluster-manager';
import { BRAND_CLUSTER_CONFIG } from './config';

/** Brand > Search Performance > Cluster Manager. */
export default function BrandClusterManager() {
  const { countriesData, isLoading } = useCountryData();
  return <ClusterManager config={BRAND_CLUSTER_CONFIG} countries={countriesData} isLoadingCountries={isLoading} />;
}
